




import { Component, Vue } from 'vue-property-decorator'
import Tariffs from '../Tarification/Tariffs.vue';
import { TarificationTypes, TarificationTransports } from "@/store/tarification/types";

@Component({ components: {Tariffs} })
export default class MNPartnerTariffs extends Vue {
  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private tarificationTransport: TarificationTransports = TarificationTransports.MAILNOTIFY;
}
